module.exports = __webpack_public_path__ + "assets/img/tx15_4.fad81e89.jpg";